var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 13.375,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 15",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 10",
    d: "M10.25 13.375c4.7 0 10.25-3.805 10.25-6.687S14.95 0 10.25 0 0 3.805 0 6.688s5.55 6.687 10.25 6.687Zm0-1.5c-3.964 0-8.75-3.28-8.75-5.187S6.286 1.5 10.25 1.5 19 4.78 19 6.688s-4.786 5.187-8.75 5.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 11",
    d: "M10.25 11a4.313 4.313 0 1 0-4.312-4.312A4.312 4.312 0 0 0 10.25 11Zm0-1.5a2.813 2.813 0 1 1 2.813-2.812A2.813 2.813 0 0 1 10.25 9.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye1.064836d614e89ea85f2964f448de439f.svg";
export { ForwardRef as ReactComponent };